export const TIME_RANGES = [
  { id: '7d', label: 'Last 7 days', days: 7 },
  { id: '14d', label: 'Last 14 days', days: 14 },
  { id: '30d', label: 'Last 30 days', days: 30 },
  { id: '90d', label: 'Last 90 days', days: 90 },
  { id: '180d', label: 'Last 180 days', days: 180 },
  { id: '270d', label: 'Last 270 days', days: 270 },
  { id: '360d', label: 'Last 360 days', days: 360 },
];

export const DEFAULT_ANALYTICS_TIME_RANGE = TIME_RANGES[1];
export const MAX_HOURLY_POINTS = 2200;

export function downsampleHourlySeries(rawSeries, maxPoints = MAX_HOURLY_POINTS) {
  if (!Array.isArray(rawSeries)) {
    return [];
  }
  if (rawSeries.length <= maxPoints) {
    return rawSeries;
  }

  const step = Math.max(1, Math.ceil(rawSeries.length / maxPoints));
  const lastIndex = rawSeries.length - 1;

  return rawSeries.filter((_, index) => index % step === 0 || index === lastIndex);
}

export function prepareChartHourlySeries(rawSeries, days, maxPoints = MAX_HOURLY_POINTS) {
  if (days > 90) {
    return downsampleHourlySeries(rawSeries, maxPoints);
  }
  return rawSeries;
}
